<template>
  <tr>
    <th width="50%" class="c-text--center">
      <template v-if="item.isYearPay">
        {{ item.periodStart | dateText('YYYY年M月') }}～{{
          item.periodEnd | dateText('YYYY年M月')
        }}分
      </template>
      <template v-else>
        {{ usageMonth | dateText('YYYY年M月') }} ご利用分
      </template>
    </th>
    <td width="25%" class="c-text--center">
      <a v-if="item.invoiceUrl" :href="item.invoiceUrl" target="_blank">
        <Icon2 variant="download" :size="13" />請求書DL
      </a>
      <template v-else>
        作成中
      </template>
    </td>
    <td
      class="c-text--center"
      :class="{ 'c-text--accent': !item.isPayPlan && !item.isPaid }"
    >
      {{ status }}
    </td>
  </tr>
</template>

<script>
import Icon2 from '@/components/Icon2';

export default {
  props: ['item'],
  components: {
    Icon2
  },
  computed: {
    paymentMonth() {
      // 決済予定月
      let date = new Date(this.item.periodEnd);
      // date.setMonth(date.getMonth() + 1);
      return this.$options.filters.dateText(date, 'M');
    },

    usageMonth() {
      // 決済予定月
      let date = new Date(this.item.periodEnd);
      date.setMonth(date.getMonth() - 1);
      return date;
    },

    status() {
      if (this.item.isPayPlan) {
        return this.paymentMonth + '/5予定';
      } else if (this.item.isPaid) {
        return '決済済み';
      } else {
        return '決済失敗';
      }
    }
  }
};
</script>
